import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Notification } from '@lib/models';
import { BaseComponent } from '@lib/classes';

@Component({
  selector: 'app-notifications-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notifications-list.component.html',
  styleUrl: './notifications-list.component.scss',
})
export class NotificationsListComponent extends BaseComponent {
  @Input() notifications: Notification[] = [];
  @Input() emptyMessage = 'No notifications yet';

  @Output() itemClick = new EventEmitter<Notification>();

  constructor() {
    super();
  }

  onItemClick(notification: Notification) {
    this.itemClick.emit(notification);
  }
}
